module.exports = __webpack_public_path__ + "assets/images/bag-residual.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bag-residual.png
// module id = 1489
// module chunks = 1